import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AxiosUrl from "../../../AxiosUrl";
import styles from "./Tracking.module.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "2px solid #00000038",
  boxShadow: 24,
  p: 2,
  maxHeight: "95vh",
  overflowY: "auto",
  "@media (min-width: 600px)": {
    width: 400,
  },
};

// Google tag fields, checked the way the backend (UpdateDomain.js) saves them:
// a pasted tag snippet is reduced to the ID inside it; an empty field clears
// the setting. Universal Analytics (UA-…) IDs stopped working in July 2023.
const GOOGLE_TAG = /\b(G-[A-Z0-9]{4,15}|GTM-[A-Z0-9]{4,12}|AW-\d{5,15})\b/;
function googleTag(raw) {
  const value = String(raw || "").trim();
  if (!value) return { value: "" };
  const id = value.toUpperCase().match(GOOGLE_TAG);
  if (id) return { value: id[1] };
  if (/\bUA-\d+-\d+\b/i.test(value)) return { error: "Universal Analytics (UA-…) stopped working in July 2023. Use your GA4 Measurement ID (G-XXXXXXXXXX)." };
  return { error: "Enter a GA4 ID (G-XXXXXXXXXX), a Tag Manager ID (GTM-XXXXXXX) or a Google Ads ID (AW-XXXXXXXXX)." };
}

function TrackingModal({ setTrackingModal, setRefresh, Refresh, Data }) {
  const [GoogleAnalytic, setGoogleAnalytic] = useState(
    Data?.GoogleAnalytic || ""
  );
  const [GoogleAdsTag, setGoogleAdsTag] = useState(Data?.GoogleAdsTag || "");
  const [GoogleAdsPurchaseLabel, setGoogleAdsPurchaseLabel] = useState(Data?.GoogleAdsPurchaseLabel || "");
  const [pixel, setPixel] = useState(Data?.pixel || "");
  const [FAccessToken, setFAccessToken] = useState(Data?.FAccessToken || "");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const uid = localStorage.getItem("id");

  const submitDomain = () => {
    const ga = googleTag(GoogleAnalytic);
    // a conversion's send_to (AW-123…/label) pasted into the label field
    const sendTo = String(GoogleAdsPurchaseLabel || "").trim().match(/^(AW-\d{5,15})\/([A-Za-z0-9_-]{4,64})$/i);
    const ads = googleTag(sendTo && !GoogleAdsTag.trim() ? sendTo[1] : GoogleAdsTag);
    const label = sendTo ? sendTo[2] : String(GoogleAdsPurchaseLabel || "").trim();
    const next = {};
    if (ga.error) next.GoogleAnalytic = ga.error;
    if (ads.error) next.GoogleAdsTag = ads.error;
    if (label && !/^[A-Za-z0-9_-]{4,64}$/.test(label)) next.GoogleAdsPurchaseLabel = "Only the label part of the conversion (letters, digits, - and _).";
    setErrors(next);
    if (Object.keys(next).length) { toast.error(Object.values(next)[0]); return; }

    setGoogleAnalytic(ga.value);
    setGoogleAdsTag(ads.value);
    setGoogleAdsPurchaseLabel(label);
    setLoading(true);
    AxiosUrl.post(`/update-domain-new/${uid}`, {
      uid,
      pixel,
      FAccessToken,
      GoogleAnalytic: ga.value,
      GoogleAdsTag: ads.value,
      GoogleAdsPurchaseLabel: label,
    })
      .then(() => {
        setRefresh(Refresh + 1);
        setTrackingModal(false);
        setLoading(false);
      })
      .catch((error) => {
        const message = typeof error?.response?.data === "string" ? error.response.data : "Could not save. Please try again.";
        toast.error(message);
        setLoading(false);
      });
  };

  return (
    <Modal
      open={setTrackingModal}
      onClose={() => setTrackingModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableScrollLock={true}
    >
      <Box sx={style}>
        <ToastContainer />
        <div className={styles.titleCloseBtn} style={{ textAlign: "right" }}>
          <Button
            onClick={() => setTrackingModal(false)}
            style={{ color: "red" }}
          >
            X
          </Button>
        </div>

        <div className={styles.title}>
          <Box sx={{ width: "100%", marginBottom: "16px" }}>
            <TextField
              placeholder="FaceBook Pixel"
              fullWidth
              label="FaceBook Pixel"
              onChange={(e) => setPixel(e.target.value)}
              value={pixel}
            />
          </Box>
          <Box sx={{ width: "100%", marginBottom: "10px" }}>
            <TextField
              placeholder="Write Access Token"
              fullWidth
              label="FaceBook Conversions API"
              onChange={(e) => setFAccessToken(e.target.value)}
              value={FAccessToken}
            />
          </Box>
          <Box sx={{ width: "100%", marginTop: "15px" }}>
            <TextField
              placeholder="G-XXXXXXXXXX"
              fullWidth
              label="Google Analytics 4 (G-…) or Tag Manager (GTM-…)"
              onChange={(e) => setGoogleAnalytic(e.target.value)}
              value={GoogleAnalytic}
              error={Boolean(errors.GoogleAnalytic)}
              helperText={errors.GoogleAnalytic || "GA4 → Admin → Data streams → Measurement ID. Leave empty to remove."}
            />
          </Box>
          <Box sx={{ width: "100%", marginTop: "15px" }}>
            <TextField
              placeholder="AW-XXXXXXXXX"
              fullWidth
              label="Google Ads (AW-…) or Tag Manager (GTM-…)"
              onChange={(e) => setGoogleAdsTag(e.target.value)}
              value={GoogleAdsTag}
              error={Boolean(errors.GoogleAdsTag)}
              helperText={errors.GoogleAdsTag}
            />
          </Box>
          <Box sx={{ width: "100%", marginTop: "15px" }}>
            <TextField
              placeholder="Purchase Conversion Label"
              fullWidth
              label="Google Ads Purchase Label"
              onChange={(e) => setGoogleAdsPurchaseLabel(e.target.value)}
              value={GoogleAdsPurchaseLabel}
              error={Boolean(errors.GoogleAdsPurchaseLabel)}
              helperText={errors.GoogleAdsPurchaseLabel || "The part after / in the conversion's send_to (AW-…/label)."}
            />
          </Box>
        </div>

        <div style={{ marginTop: 20, textAlign: "right" }}>
          <Button
            onClick={() => setTrackingModal(false)}
            variant="outlined"
            style={{ marginRight: 10 }}
          >
            Cancel
          </Button>
          <Button onClick={submitDomain} variant="contained" disabled={loading}>
            {loading ? "Loading.." : "Continue"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default TrackingModal;
